import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSiteConfig } from "@/context/SiteConfigContext";

const IMG = "https://images.unsplash.com/photo-1649769069590-268b0b994462?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxzbWlsaW5nJTIwbWVjaGFuaWMlMjB0YWJsZXR8ZW58MHx8fHwxNzg2MjI3ODkyfDA&ixlib=rb-4.1.0&q=85";

export default function ProviderSection() {
  const { config } = useSiteConfig();
  const t = config.t.provider;
  const PROVIDER_BENEFITS = config.lists.providerBenefits;
  return (
    <section id="providers" className="relative overflow-hidden bg-[#0A0A0A] py-28 text-white sm:py-40" data-testid="provider-section">
      <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-brand/20 blur-[130px]" />
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-6 lg:grid-cols-2">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-ai">{t.badge}</span>
          <h2 className="mt-6 text-4xl font-bold tracking-tighter sm:text-5xl lg:text-6xl">{t.heading}</h2>
          <p className="mt-5 max-w-md text-lg text-white/60">
            {t.paragraph}
          </p>

          <ul className="mt-8 grid gap-3 sm:grid-cols-2">
            {PROVIDER_BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5 text-[15px] text-white/80">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-ai/20 text-ai"><Check className="h-3 w-3" strokeWidth={3} /></span>
                {b}
              </li>
            ))}
          </ul>

          <Link to="/providers" className="mt-10 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-base font-semibold text-neutral-900 transition-transform hover:bg-white/90 active:scale-95" data-testid="become-provider-btn">
            {t.cta} <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>

        <Reveal delay={0.1}>
          <motion.div whileHover={{ scale: 1.01 }} className="relative overflow-hidden rounded-3xl">
            <img src={IMG} alt="Service provider" className="h-full min-h-[420px] w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <div className="glass-dark absolute bottom-6 left-6 right-6 rounded-2xl p-5">
              <div className="flex items-center justify-between">
                <div><p className="text-xs uppercase tracking-wide text-white/50">New request nearby</p><p className="text-lg font-bold">Flat tire · 1.2 mi away</p></div>
                <span className="rounded-full bg-ai px-3 py-1.5 text-xs font-bold text-black">Accept</span>
              </div>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
